import { Outlet, useOutletContext } from 'react-router-dom'

import { EmployeesCustomTablesListPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { PortalWrapper } from 'modules/core/components/PortalWrapper'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import List from 'modules/employees/components/CustomTables/List'
import type { CommonRouteContext } from 'modules/employees/lib/types'
import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'

import { type RootRoute, RouteContext } from './context'

interface Props {
  rootRoute: RootRoute
}

export default function CustomTablesListPage({ rootRoute }: Props) {
  const { headerTitle } = useOutletContext<CommonRouteContext>()
  const { id: employeeIdparam } = useStrictParams<'id'>()
  const { employee: sessionEmployee } = useCurrentSession()

  const employeeId = employeeIdparam ? Number(employeeIdparam) : sessionEmployee.id

  const { data, loading } = useQuery(EmployeesCustomTablesListPageDocument, {
    variables: {
      employeeId: employeeId,
    },
  })

  const schemas = data?.customResources.schemas ?? []

  return (
    <RouteContext.Provider value={rootRoute}>
      <Page.Body>
        <PortalWrapper container={headerTitle}>
          <Header.Title>{i18n.t('custom_tables.title')}</Header.Title>
        </PortalWrapper>

        {loading && <Loading />}
        {!loading && (
          <>
            <List attachableId={employeeId} schemas={schemas} />
            <Outlet />
          </>
        )}
      </Page.Body>
    </RouteContext.Provider>
  )
}
